import React from "react";
import { Col, Row } from "react-bootstrap";
import LayoutImage from "../../assets/Images/staticImages/freshveggi.png";

function WhyPaicho() {
  return (
    <section className="layoutWrapper1">
      <Row>
        <Col lg={6}>
          <section className="whyImage1">
            <img src={LayoutImage} alt="" />
          </section>
        </Col>
        <Col lg={6}>
          <section className="whyContentWrapper1">
            <section className="whyContent1">
              <div className="preTitle">Why paicho</div>
              <h2 className="mainTitle">We Provide More Fresh Products. </h2>

              <ul className="whyLIst1">
                <li className="flex-between whyLIst1__box ">
                  <div>
                    <i className="fa fa-check cpr"></i>
                  </div>
                  <p>
                    Products generated in hilly areas are delicious letting
                    consumers to relieve their local flavor.
                  </p>
                </li>
                <li className="flex-between whyLIst1__box ">
                  <div>
                    <i className="fa fa-check cpr"></i>
                  </div>
                  <p>
                    Fruits and vegetables generated in hilly areas and food
                    items processed are easily digestible and enriched in
                    antioxidants.
                  </p>
                </li>
                <li className="flex-between whyLIst1__box ">
                  <div>
                    <i className="fa fa-check cpr"></i>
                  </div>
                  <p>
                    Eating diet rich in green vegetables and fruits produced in
                    hilly areas makes body healthy, fit and strong.
                  </p>
                </li>
                <li className="flex-between whyLIst1__box ">
                  <div>
                    <i className="fa fa-check cpr"></i>
                  </div>
                  <p>
                    Experts opine that such foods also improve sexual
                    performance and immunity power.
                  </p>
                </li>
              </ul>
            </section>
          </section>
        </Col>
      </Row>
    </section>
  );
}

export default WhyPaicho;
